<template>
  <table class="table-sm" style="width: 100%; background: #95b4ff30">
    <thead>
      <tr>
        <th nowrap class="text-center border-gray" width="28%">Campo</th>
        <th nowrap class="text-center border-gray" width="36%">Valor antigo</th>
        <th nowrap class="text-center border-gray" width="36%">Valor novo</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in rows" :key="row.key">
        <td :title="row.auditId" class="border-gray">
          {{ row.label }}
        </td>
        <td class="text-center border-gray">{{ row.oldValue }}</td>
        <td class="text-center border-gray">{{ row.newValue }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'CustomerContractHistoryValuesTable',
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
